import * as React from 'react';

import InsightsReportsQueriesInputField from 'modules/insights/reports/components/queries/inputs/field/InsightsReportsQueriesInputField';

import { __t, applyTranslations } from 'utils/language';

import './insights-reports-queries-modal-step-details-kpi.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));

import type {
  QueryFieldType
} from 'modules/insights/reports/types';

type Props = {
  fieldType: 'impressions' | 'reach',
  value: string,
  placeholder: string,
  onTextFieldChange: (fieldType: QueryFieldType, value: string) => void
};

const COLLABARY_MSG_KEY = 'collabary_common';

const InsightsReportsQueriesModalStepDetailsKpi: React.FunctionComponent<Props> = ({
  fieldType,
  value,
  placeholder,
  onTextFieldChange
}: Props) => (
  <div className="insights-reports-queries-modal-step-details-kpi">
    <div className="insights-reports-queries-modal-step-details-kpi__row">
      <div className="insights-reports-queries-modal-step-details-kpi__label">
        {__t(`${COLLABARY_MSG_KEY}.kpis.${fieldType}`)}:
      </div>
      <div className="insights-reports-queries-modal-step-details-kpi__field">
        <InsightsReportsQueriesInputField
          key={`insights-reports-queries-modal-step-details-kpi__input--${fieldType}}`}
          fieldType={fieldType}
          value={value !== placeholder ? value : ''}
          placeholder={placeholder}
          hint="%"
          onChange={onTextFieldChange}
        />
      </div>
      <div className="insights-reports-queries-modal-step-details-kpi__sublabel">
        x {__t(`${COLLABARY_MSG_KEY}.basics.followers`)}
      </div>
    </div>
  </div>
);

export default InsightsReportsQueriesModalStepDetailsKpi;
